<template>
  <div id="Vitals-form">
    <div class="col-md-12">
      <div class="row" style="margin-top: 1em">
        <div class="col-md-6 col-lg-4" v-for="(device, index) in deviceProfile" :key="device.identifier" :id="device.identifier">
          <vital-card :deviceforcard="device" :vitals="vitals.deviceData" :vital-index="index" ref="vitalComponents" v-if="device.communication.communicationMethod != 'NOTIFY'" :error-messages="errorMessages" :historic-vitals="historicVitals" :allowManualEntry="true" :allowRetrieval="IS_PATIENT" :shareButton="false" :uploadButton="true"></vital-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vitalCard from "../components/VitalCard";
import v8n from "v8n";
import { mapState } from "vuex";
import moment from "moment-timezone";

export default {
  name: "vitals",

  components: {
    vitalCard,
  },

  async mounted() {
    this.IS_PATIENT = this.user.roles.includes("patient");

    this.deviceProfile = await this.getDeviceProfile();
    this.deviceProfile.forEach((device) => {
      device.vitals.forEach((vital) => {
        this.$set(this.errorMessages, vital.identifier, []);
      });

      //After scanning vitals by OCR. Populate scanned vitals
      let scannedDevice = this.scannedDevices.find((sd) => {
        return sd.identifier == device.identifier;
      });

      if (scannedDevice) {
        device.vitals = scannedDevice.vitals;
      }
    });

    //Clear scanned vitals data after populating
    this.$store.commit("setState", {
      stateName: "scannedDevices",
      stateValue: [],
    });

    try {
      this.historicVitals = await this.$store.dispatch("getVitalHistory", {
        patientId: this.patient.patientId,
        deviceProfile: this.deviceProfile,
        fromTime: moment().subtract(30, "days").unix() * 1000,
        toTime: moment().unix() * 1000,
      });
    } catch (e) {
      console.log(e);
    }
  },

  data() {
    return {
      validatedVitalCount: 0,
      vitals: {
        deviceData: {},
      },
      errorMessages: {},
      historicVitals: null,
      deviceProfile: [],
      IS_PATIENT: false,
    };
  },

  computed: {
    ...mapState({
      patient: "patient",
      scannedDevices: (state) => state.scannedDevices,
    }),
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },

    endpoint() {
      return this.$store.state.endpoint;
    },
  },

  methods: {
    async getDeviceProfile() {
      try {
        let deviceProfile = [];
        //get device profile from configurations
        let response = await this.$store.dispatch(
          "getConfigurationByEndpointId",
          {
            endpointId: this.endpoint._id,
            type: "deviceProfile",
          }
        );
        if (response && response.value) {
          deviceProfile = response.value;
        }

        this.$store.state.deviceProfile = deviceProfile;
        return this.$store.state.deviceProfile;
      } catch (e) {
        console.log(e);
        return [];
      }
    },

    timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    validateReading(validationsMetadata, reading) {
      var validationResults = [];
      for (var i in Object.keys(validationsMetadata)) {
        var validationCheckRule = Object.keys(validationsMetadata)[i];
        var validationCheckValue = validationsMetadata[validationCheckRule];
        var v8nFunc = null;
        if (
          [
            "string",
            "number",
            "numeric",
            "integer",
            "boolean",
            "undefined",
            "null",
            "array",
            "object",
            "empty",
            "negative",
            "positive",
            "even",
            "odd",
          ].indexOf(validationCheckRule) > -1
        ) {
          if (validationCheckValue) {
            v8nFunc = v8n()[validationCheckRule]();
          } else {
            v8nFunc = v8n().not[validationCheckRule]();
          }
        } else if (["between"].indexOf(validationCheckRule) > -1) {
          var arg1 = validationCheckValue[0];
          var arg2 = validationCheckValue[1];
          v8nFunc = v8n()[validationCheckRule](arg1, arg2);
        } else if (validationCheckRule == "pattern") {
          var regex = new RegExp(
            validationCheckValue.substring(1, validationCheckValue.length - 2),
            validationCheckValue.charAt(validationCheckValue.length - 1)
          );
          v8nFunc = v8n()[validationCheckRule](regex);
        } else {
          v8nFunc = v8n()[validationCheckRule](validationCheckValue);
        }
        if (v8nFunc && !v8nFunc.test(reading.value)) {
          validationResults.push({
            validationCheckRule,
            validationCheckValue,
          });
        }
      }

      return validationResults;
    },
  },

  beforeDestroy() {
    this.deviceProfile.forEach((device) => {
      device.vitals.forEach((vital) => {
        vital.value = "";
      });
    });
  },
};
</script>
